<template>
    <AppFormValidator
        ref="validator"
        :model="model"
        :rules="rules"
    >
        <CForm @submit.prevent>
            <CInput
                v-model="model.title"
                horizontal
                label="Название"
                placeholder="Введите навание акции"
            />

            <CRow
                v-if="allRestaurants"
                form
                class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3"> Рестораны </CCol>
                <CCol sm="9">
                    <div class="flex flex-wrap">
                        <div
                            v-for="restaurant in allRestaurants"
                            :key="restaurant.id"
                            class="w-1/4"
                        >
                            <CInputCheckbox
                                :checked.sync="restaurantsSelected[restaurant.id]"
                                :label="restaurant.title"
                                :disabled="model.all_restaurants"
                            />
                        </div>
                    </div>
                </CCol>
            </CRow>

            <CRow
                v-if="allGrocers"
                form
                class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Магазины продуктов
                </CCol>
                <CCol sm="9">
                    <div class="flex flex-wrap">
                        <div
                            v-for="grocer in allGrocers"
                            :key="grocer.id"
                            class="w-1/4">
                            <CInputCheckbox
                                :checked.sync="grocersSelected[grocer.id]"
                                :label="grocer.title"
                                :disabled="model.all_grocers"
                            />
                        </div>
                    </div>
                </CCol>
            </CRow>

            <CRow
                v-if="allPharmacies"
                form
                class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3"> Аптеки </CCol>
                <CCol sm="9">
                    <div class="flex flex-wrap">
                        <div
                            v-for="pharmacy in allPharmacies"
                            :key="pharmacy.id"
                            class="w-1/4"
                        >
                            <CInputCheckbox
                                :checked.sync="pharmaciesSelected[pharmacy.id]"
                                :label="pharmacy.title"
                                :disabled="model.all_pharmacy"
                            />
                        </div>
                    </div>
                </CCol>
            </CRow>

            <CRow
                v-if="allAssistants"
                form
                class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3"> Помощники </CCol>
                <CCol sm="9">
                    <div class="flex flex-wrap">
                        <div
                            v-for="assistant in allAssistants"
                            :key="assistant.id"
                            class="w-1/4"
                        >
                            <CInputCheckbox
                                :checked.sync="assistantsSelected[assistant.id]"
                                :label="assistant.title"
                                :disabled="model.all_assistants"
                            />
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div v-if="entityTypes">
                <CRow
                    v-for="type in entityTypes"
                    :key="type.id"
                    form
                    class="form-group">
                    <CCol
                        tag="label"
                        class="col-form-label"
                        sm="3"> {{ type.title }} </CCol>
                    <CCol sm="9">
                        <div v-if="type.services && type.services.length" class="flex flex-wrap">
                            <div
                                v-for="entityService in type.services"
                                :key="entityService.id"
                                class="w-1/4"
                            >
                                <CInputCheckbox
                                    :checked.sync="entitiesSelected[entityService.id]"
                                    :label="entityService.title"
                                    :disabled="disabledEntities[type.code]"
                                />
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </div>
            <ScheduleUpdate :schedule="schedule" @set-schedule="setSchedule"/>
            <CInput v-model="model.discount" label="Скидка" />
            <CInput v-model="model.orders_quantity" label="Количество первых заказов в заведении по акции" />
            <CInput v-model="model.entity_discount_percent" label="Размер скидки от ресторана (%)" />
            <CInput v-model="model.entity_discount_sum" label="Размер скидки от ресторана (руб.)" />
            <CInput v-model="model.mircity_commission" label="Размер комиссии МИРСИТИ (%)" />
            <CRow class="mb-1 mt-4">
                <CCol cols="12" md="2"> Дата начала: </CCol>
                <CCol cols="12" md="4">
                    <DatePicker
                        v-model="datepicker.dateFrom"
                        :language="datepicker.lang"
                        :format="datepicker.format"
                        input-class="custom-datepicker"
                        placeholder="Выберите дату..."
                    />
                </CCol>
                <CCol cols="12" md="2"> Дата окончания: </CCol>
                <CCol cols="12" md="4">
                    <DatePicker
                        v-model="datepicker.dateTo"
                        :language="datepicker.lang"
                        :format="datepicker.format"
                        input-class="custom-datepicker"
                        placeholder="Выберите дату..."
                    />
                </CCol>
            </CRow>
            <CRow class="mt-4 mb-2 align-items-center">
                <CCol cols="12" md="2"> Время (от) </CCol>
                <CCol cols="12" md="4">
                    <CInput
                        v-model="model.time_from"
                        class="m-0"
                        type="time" />
                </CCol>
                <CCol cols="12" md="2"> Время (до) </CCol>
                <CCol cols="12" md="4">
                    <CInput
                        v-model="model.time_to"
                        class="m-0"
                        type="time" />
                </CCol>
            </CRow>
            <CRow class="pl-3 mb-4">
                <CButton
                    color="light"
                    class="mr-3"
                    @click="resetDate"
                >Сброс дат и времени</CButton>
            </CRow>


            <CRow form class="form-group">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">Тип доставки</CCol>
                <CCol sm="9">
                    <CSelect
                        inline
                        :value.sync="model.delivery_type"
                        :options="delivery_types"
                        placeholder="Тип доставки..."
                    />
                </CCol>
            </CRow>

            <CRow>
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Неограничено по времени
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.unlimited"
                    />
                </CCol>
            </CRow>

            <CRow>
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Учитывать при интеграции
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.accounting_in_integration"
                    />
                </CCol>
            </CRow>

            <CRow>
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label"> Активен </CCol>
                <CCol sm="9">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled"
                    />
                </CCol>
            </CRow>

            <div class="flex mt-4">
                <CButton
                    color="primary"
                    @click="submit"
                >{{ submitButtonTitle }}
                </CButton>
                <CButton
                    v-if="model.id"
                    variant="outline"
                    color="danger"
                    class="ml-4"
                    @click="promptDelete"
                >Удалить
                </CButton>
            </div>
        </CForm>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete"
        />
    </AppFormValidator>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import { requiredRule } from '@/utils/rules';
    import moment from 'moment';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    import ScheduleUpdate from '@/components/ScheduleWorkPromotionUpdate';
    const { DELIVERY_TYPE } = require('../../utils/order');

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
            DatePicker,
            ScheduleUpdate,
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                schedule: undefined,
                model: {},
                schema: {
                    id: 'id',
                    title: 'title',
                    type: 'type',
                    date_start: 'date_start',
                    date_finish: 'date_finish',
                    time_from: 'time_from',
                    time_to: 'time_to',
                    discount: 'discount',
                    orders_quantity: 'orders_quantity',
                    entity_discount_percent: 'entity_discount_percent',
                    entity_discount_sum: 'entity_discount_sum',
                    mircity_commission: 'mircity_commission',
                    restaurants: 'restaurants',
                    grocers: 'grocers',
                    pharmacy: 'pharmacy',
                    assistants: 'assistants',
                    entity_types: 'entity_types',
                    entities: 'entities',
                    delivery_type: 'delivery_type',
                    all_restaurants: source => Boolean(source.all_restaurants),
                    all_grocers: source => Boolean(source.all_grocers),
                    all_pharmacy: source => Boolean(source.all_pharmacy),
                    all_assistants: source => Boolean(source.all_assistants),
                    common: source => Boolean(source.common),
                    unlimited: source => Boolean(source.unlimited),
                    accounting_in_integration: source => Boolean(source.accounting_in_integration),
                    enabled: source => Boolean(source.enabled),
                },
                rules: {
                    enabled: [requiredRule],
                },
                // Restaurants
                allRestaurants: [],
                restaurantsSelected: [],
                // Grocers
                allGrocers: [],
                grocersSelected: [],
                // Pharmacies
                allPharmacies: [],
                pharmaciesSelected: [],
                // Assistants
                allAssistants: [],
                assistantsSelected: [],
                // Entity types
                entityTypes: [],
                entityTypesSelected: [],
                entitiesSelected: [],
                disabledEntities: {},
                delivery_types: null,

                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
            };
        },

        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },

        },

        created() {
            this.setModel();
            this.initBusiness();
        },

        async mounted() {
            await this.fetch();
        },

        methods: {
            setSchedule(schedule) {
                this.schedule = schedule;
            },
            async fetch() {
                try {
                    const id = this.$route.params.id;
                    if (id) {
                        const promotion = await Vue.axios.get('/common-promotions/' + id);
                        this.model = promotion.data;

                        if (promotion.data.schedule.length != 0) {
                            this.schedule = promotion.data.schedule;
                        }

                        if(promotion.data.date_start) {
                            this.model.date_start = moment(promotion.data.date_start).format('YYYY-MM-DD');
                            this.datepicker.dateFrom = moment(promotion.data.date_start).format('YYYY-MM-DD');
                        }
                        if(promotion.data.date_finish) {
                            this.datepicker.dateTo = moment(promotion.data.date_finish).format('YYYY-MM-DD');
                            this.model.date_finish = moment(promotion.data.date_finish).format('YYYY-MM-DD');
                        }
                        this.model.time_from = promotion.data.time_from
                            ? moment('Mon Jun 28 2021 ' + promotion.data.time_from + ' GMT+0000').local().format('HH:mm:ss')
                            : null;
                        this.model.time_to = promotion.data.time_to
                            ? moment('Mon Jun 28 2021 ' + promotion.data.time_to + ' GMT+0000').local().format('HH:mm:ss')
                            : 0;
                    }
                    if(!this.delivery_types) {
                            const types = [];
                            types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                            types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                            types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                            types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });
                            types.push({ value: null, label: 'Без типа доставки' });
                            this.delivery_types = types;
                        }
                } catch(e) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            disableEntity(event, code) {
                this.disabledEntities[code] = event.target.checked;
            },
            setModel() {
                this.model = morphism(this.schema, this.entity);
            },

            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                const { id, ...payload } = this.model;

                // Restaurants
                const restaurants = [];
                for (const restaurant of this.allRestaurants) {
                    if (this.restaurantsSelected[restaurant.id]) {
                        restaurants.push(restaurant.id);
                    }
                }
                payload.restaurants = restaurants;
                // Grocers
                const grocers = [];
                for (const grocer of this.allGrocers) {
                    if (this.grocersSelected[grocer.id]) {
                        grocers.push(grocer.id);
                    }
                }
                payload.grocers = grocers;
                // Pharmacies
                const pharmacies = [];
                for (const pharmacy of this.allPharmacies) {
                    if (this.pharmaciesSelected[pharmacy.id]) {
                        pharmacies.push(pharmacy.id);
                    }
                }
                payload.pharmacy = pharmacies;
                // Assistants
                const assistants = [];
                for (const assistant of this.allAssistants) {
                    if (this.assistantsSelected[assistant.id]) {
                        assistants.push(assistant.id);
                    }
                }
                payload.assistants = assistants;
                // Entities
                const entities = [];
                const entityTypes = [];
                if (this?.entityTypes?.length) {
                    for (const type of this.entityTypes) {
                        if (this.entityTypesSelected[type.id]) {
                            entityTypes.push(type.id);
                        }
                        if (type?.services?.length) {
                            for (const entity of type.services) {
                                if (this.entitiesSelected[entity.id]) {
                                    entities.push(entity.id);
                                }
                            }
                        }
                    }
                }
                payload.entities = entities;
                payload.entity_types = entityTypes;
                payload.delivery_type === this.model.delivery_type;
                payload.schedule = this.schedule;
                payload.discount = payload.discount ? +payload.discount : null;
                payload.orders_quantity = payload.orders_quantity ? +payload.orders_quantity : null;
                payload.entity_discount_percent = payload.entity_discount_percent ? +payload.entity_discount_percent : null;
                payload.entity_discount_sum = payload.entity_discount_sum ? +payload.entity_discount_sum : null;
                payload.mircity_commission = payload.mircity_commission ? +payload.mircity_commission : null;
                payload.type = 1; // Promotion discount type
                payload.common = true; // Promotion discount type
                payload.date_start = this.datepicker.dateFrom ? moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD') : null;
                payload.date_finish = this.datepicker.dateTo ? moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD') : null;
                payload.time_from = payload.time_from
                    ? moment(payload.time_from, 'HH:mm').utc().format('HH:mm:ss')
                    : null;
                payload.time_to = payload.time_to
                    ? moment(payload.time_to, 'HH:mm').utc().format('HH:mm:ss')
                    : null;

                if (typeof id === 'number') {
                    const [err] = await to(this.axios.put(`/common-promotions/${id}`, payload));
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись.');
                    }
                } else {
                    const [err] = await to(this.axios.post('/common-promotions', payload));
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись.');
                    }
                }

                this.$emit('success');
            },

            promptDelete() {
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/common-promotions/${this.model.id}`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка удаления записи.');
                }

                this.$emit('deleted');
            },

            async initBusiness() {
                // Restaurants
                this.allRestaurants = (await this.axios.get('/restaurants')).data;
                // Grocers
                this.allGrocers = (await this.axios.get('/grocers')).data;
                // Pharmacies
                this.allPharmacies = (await this.axios.get('/pharmacies')).data;
                // Assistants
                this.allAssistants = (await this.axios.get('/assistants')).data;
                // Entities
                this.entityTypes = (await this.axios.get('/entities-type')).data;
                this.entityTypes = await Promise.all(this.entityTypes.map(async type => {
                    this.disabledEntities[type.code] = false;
                    type.services = (await this.axios.get(`/entities/${type.code}`)).data;
                    return type;
                }));
                this.initBusinessSelected();
            },

            initBusinessSelected() {
                // Restaurants
                this.allRestaurants.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this.allRestaurants.length) {
                    for (const restaurant of this.allRestaurants) {
                        this.restaurantsSelected[restaurant.id] = false;
                    }
                }
                if (
                    this.model &&
                    this.model.restaurants &&
                    this.model.restaurants.length
                ) {
                    for (const restaurant of this.model.restaurants) {
                        this.restaurantsSelected[restaurant] = true;
                    }
                }
                // Grocers
                this.allGrocers.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this.allGrocers.length) {
                    for (const grocer of this.allGrocers) {
                        this.grocersSelected[grocer.id] = false;
                    }
                }
                if (this.model && this.model.grocers && this.model.grocers.length) {
                    for (const grocer of this.model.grocers) {
                        this.grocersSelected[grocer] = true;
                    }
                }
                // Pharmacies
                this.allPharmacies.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this.allPharmacies.length) {
                    for (const pharmacy of this.allPharmacies) {
                        this.pharmaciesSelected[pharmacy.id] = false;
                    }
                }
                if (this.model && this.model.pharmacy && this.model.pharmacy.length) {
                    for (const pharmacy of this.model.pharmacy) {
                        this.pharmaciesSelected[pharmacy] = true;
                    }
                }
                // Assistants
                this.allAssistants.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this.allAssistants.length) {
                    for (const assistant of this.allAssistants) {
                        this.assistantsSelected[assistant.id] = false;
                    }
                }
                if (this.model && this.model.assistants && this.model.assistants.length) {
                    for (const assistant of this.model.assistants) {
                        this.assistantsSelected[assistant] = true;
                    }
                }
                // Entities
                this.entityTypes.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this?.entityTypes?.length) {
                    for (const type of this.entityTypes) {
                        this.entityTypesSelected[type.id] = false;
                        if (this.model && this.model.entity_types && this.model.entity_types.length) {
                            for (const id of this.model.entity_types) {
                                if (type.id === id) {
                                    this.disabledEntities[type.code] = true;
                                }
                            }
                        }
                    }
                }
                if (this.model && this.model.entity_types && this.model.entity_types.length) {
                    for (const type of this.model.entity_types) {
                        this.entityTypesSelected[type] = true;
                    }
                }
                if (this?.entityTypes?.length) {
                    for (const type of this.entityTypes) {
                        if (type?.services?.length) {
                            for (const entity of type.services) {
                                this.entitiesSelected[entity.id] = false;
                            }
                        }
                    }
                }
                if (this.model && this.model.entities && this.model.entities.length) {
                    for (const entity of this.model.entities) {
                        this.entitiesSelected[entity] = true;
                    }
                }
            },

            resetDate() {
                this.datepicker.dateFrom = null;
                this.datepicker.dateTo = null;
                this.promotion.time_from = null;
                this.promotion.time_to = null;
            },
        },
    };
</script>
<style>
input.custom-datepicker {
    padding: 0.375rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid;
    border-color: #d8dbe0;
    width: 100%;
}
</style>
